import React from 'react';

import classnames from 'classnames';

import PageNavigationTabs from 'components/uiLibrary/PageNavigationTabs';

// NOTE: disabling below es lint error to avoid commit error but this needs to be fixed
// eslint-disable-next-line import/no-cycle
import QuickFilters from 'components/Filters/Common/QuickFilters';
import { COMPONENTS, SECTIONS } from 'components/Globals/Analytics/constants';
import ContextualFootLinks from 'components/Globals/ContextualFootLinks';
import SectionBlock from 'components/Globals/SectionBlock';
import { usePaywallContext } from 'components/Paywall';
import PlanGroupListing from 'components/Paywall/PlanGroupListing';

import useAppContext from 'utils/hooks/useAppContext';
import { useDialogs } from 'utils/hooks/useDialogs';
import useEntitySectionTabs from 'utils/hooks/useEntitySectionTabs';
import usePageContext from 'utils/hooks/usePageContext';

import { useTranslation } from 'src/i18n';

import { FILTER_TYPES, TP } from 'operabase-router/constants';

import classes from './ExploreMoreWrapper.module.scss';

const ExploreMoreWrapper = ({ isHomePage }) => {
  const { t } = useTranslation('NS_APP_GLOBALS');
  const { obRouteContext, isLoggedIn } = useAppContext();
  const linkProps = obRouteContext?.linkProps;
  const { entityType, entity } = usePageContext();
  const { setShowSubscriptionPlans } = usePaywallContext();
  const { setIsLoginDialog } = useDialogs();
  const tabs = useEntitySectionTabs({
    entityType,
    entity,
    mainPath: linkProps?.tab,
    filters: linkProps?.filters,
    baseRoute: obRouteContext?.basePath,
  });
  const activeTab = tabs?.find(({ key }) => key === linkProps?.tab) || tabs?.[0];

  // Check if this is an organization without productions or performances
  const isOrganizationWithoutPerformances = entityType === 'organization' && 
    !entity?.stats?.productions?.exists;

  const onPlanGroupChoose = identifier => {
    if (isLoggedIn) {
      setShowSubscriptionPlans({
        show: true,
        identifier,
      });
    } else {
      setIsLoginDialog({ isOpen: true });
    }
  };

  const getTitle = () => {
    if (entity?.id) {
      return t(`${TP}.FN_DISCOVER_MORE_ABOUT_ENTITY`, { entityName: entity?.name });
    }

    return t(`${TP}.FN_DISCOVER_MORE`);
  };

  return (
    <SectionBlock title={getTitle()} styles={{ leftBoxIcon: isHomePage ? classes.leftBoxIcon : '' }}>
      <div className={classnames(classes.root, { [classes.root_isHomePage]: isHomePage })}>
        {!!entity?.id && (
          <>
            <PageNavigationTabs
              tabs={tabs}
              activeTab={activeTab}
              trackingData={{
                section: SECTIONS.EXPLORER_MORE,
              }}
            />
            {!isOrganizationWithoutPerformances && (
              <QuickFilters
                filterType={FILTER_TYPES.SEASON}
                limit={15}
                scrollable
                includeSpecialOptions
                skipBorder
                trackingData={{
                  section: SECTIONS.EXPLORER_MORE,
                  component: COMPONENTS.QUICK_FILTERS,
                }}
              />
            )}
          </>
        )}
        {!isOrganizationWithoutPerformances && (
          <div className={classnames(classes.footerWrapper, { [classes.footerWrapper_withoutNavigation]: !entity?.id })}>
            <ContextualFootLinks />
            <PlanGroupListing
              onChoose={onPlanGroupChoose}
              isCompressed
              trackingData={{
                section: SECTIONS.EXPLORER_MORE,
                component: COMPONENTS.PLAN_CARD,
              }}
            />
          </div>
        )}
      </div>
    </SectionBlock>
  );
};

export default ExploreMoreWrapper;
